import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { useLang } from "../../i18n";
import { scrollTo } from "../../utils";

const Nav = () => {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);

  const go = (href) => {
    setOpen(false);
    scrollTo(href);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-[#232733] bg-[#0A0B0E]/70 backdrop-blur-xl" data-testid="main-nav">
      <div className="hidden md:flex items-center justify-between px-6 lg:px-12 h-8 border-b border-[#232733] font-mono text-[10px] uppercase tracking-[0.25em] text-[#647087]">
        <span data-testid="nav-phone">{t.phone1}</span>
        <span>{t.nav.tagline}</span>
      </div>
      <div className="flex items-center justify-between px-6 lg:px-12 h-16">
        <button data-testid="nav-logo" onClick={() => go("#top")} className="flex items-center gap-2.5 group">
          <img src="/assets/logo-white.png" alt="K&K Packaging" className="h-8 w-auto" />
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#647087] group-hover:text-white transition-colors">Packaging</span>
        </button>
        <nav className="hidden lg:flex items-center gap-8">
          {t.nav.links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="font-mono text-xs uppercase tracking-[0.2em] text-[#A0AABF] hover:text-white transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <div className="flex border border-[#232733] font-mono text-[11px] uppercase">
            <button
              data-testid="lang-toggle-fr"
              onClick={() => setLang("fr")}
              className={`px-3 py-1.5 transition-colors ${lang === "fr" ? "bg-[#0055FF] text-white" : "text-[#647087] hover:text-white"}`}
            >
              FR
            </button>
            <button
              data-testid="lang-toggle-en"
              onClick={() => setLang("en")}
              className={`px-3 py-1.5 transition-colors ${lang === "en" ? "bg-[#0055FF] text-white" : "text-[#647087] hover:text-white"}`}
            >
              EN
            </button>
          </div>
          <button
            data-testid="nav-quote-btn"
            onClick={() => go("#devis")}
            className="hidden sm:flex items-center gap-2 bg-[#FF4D00] text-white font-mono text-xs uppercase tracking-[0.2em] px-5 py-2.5 hover:bg-[#0055FF] transition-colors"
          >
            {t.nav.cta} <ArrowUpRight size={14} />
          </button>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="lg:hidden text-white p-2" aria-label="Menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#232733] bg-[#0A0B0E] px-6 py-4 flex flex-col gap-4">
          {t.nav.links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-left font-mono text-sm uppercase tracking-[0.2em] text-[#A0AABF] hover:text-white transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-quote-btn"
            onClick={() => go("#devis")}
            className="flex items-center gap-2 bg-[#FF4D00] text-white font-mono text-xs uppercase tracking-[0.2em] px-5 py-3 w-fit"
          >
            {t.nav.cta} <ArrowUpRight size={14} />
          </button>
        </div>
      )}
    </header>
  );
};

export default Nav;
